import styled from 'styled-components';
import { colors, fonts } from 'shared/defaultTheme';

export const ButtonUploaderFilesWrapper = styled.div`
  font-family: ${fonts.default};
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  color: ${colors.white};
  .button-uploader-container {
    cursor: pointer;
    border-radius: 0 0 8px 8px;
    background-color: ${colors.whiteSmoke};
  }
  .button-uploader-info {
    height: 39px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  svg {
    height: 24px;
    width: 24px;
  }
  /* &:hover {
    border: 1px solid ${colors.spanishGray};
    border-radius: 2px;
    color: ${colors.suvaGrey};
    svg {
      fill: ${colors.suvaGrey};
    }
  } */
`;

export const SpanCustom = styled.span``;
